import type { ComponentProps } from "react"
import * as VisuallyHidden from "@radix-ui/react-visually-hidden"
import { DialogDescription as DialogDescriptionBase } from "@/v2-ui/dialog/base/DialogBase"
import cn from "@/v2-ui/utils/utils.cn"
import ConditionalWrapper from "@/v2-ui/ConditionalWrapper"

export type DialogDescriptionProps = ComponentProps<
  typeof DialogDescriptionBase
> & {
  isVisuallyHidden?: boolean
}

function DialogDescription(props: DialogDescriptionProps) {
  const { isVisuallyHidden, className, ...dialogDescriptionBaseProps } = props
  return (
    <ConditionalWrapper
      condition={isVisuallyHidden}
      renderWrapper={(children) => (
        <VisuallyHidden.Root>{children}</VisuallyHidden.Root>
      )}
    >
      <DialogDescriptionBase
        className={cn("ui-dialog-description", className)}
        {...dialogDescriptionBaseProps}
      />
    </ConditionalWrapper>
  )
}

export default DialogDescription
